// Update this file when company branding changes.
export const COMPANY = {
  name: "AtServiceCRM",
  logo: "/dist/img/logo.png",
  tagline: "Service operations, made simple.",
  description:
    "Manage bookings, partners, service centers, and support from one secure workspace.",
  copyrightYear: "2026",
};
